import { fetchGetCreditCardOffers } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useGetCreditCardOffer = () => {
    const stateKey = useStateKey();

    const {
        data: creditCardOffer,
        isLoading: getCreditCardOfferLoading,
        isError: getCreditCardOfferError
    } = useQuery({
        queryKey: ['credit_card_offer', stateKey],
        queryFn: () =>
            fetchGetCreditCardOffers({
                stateKey
            }),
        select: (data) => data.data
    });

    return {
        creditCardOffer,
        getCreditCardOfferLoading,
        getCreditCardOfferError
    };
};
